import type { ReactNode } from "react";
import { useSuperUserView } from "@/features/navigation/hooks/useSuperUserView";

/** Renders its children only in the super user view. Display only: RLS and route guards still decide access. */
export default function SuperUserOnly({ children }: { children: ReactNode }) {
    const { isSuperUserView } = useSuperUserView();
    return isSuperUserView ? children : null;
}
